import Point from './Point.js';
import Size from './Size.js';

export default class Bounds {
    lt = new Point();
    rb = new Point();

    addPoint(point, size = null) {
        if (!(point instanceof Point)) {
            throw new Error('point must be an instance of Point');
        }

        if (this.lt.x === null || point.x < this.lt.x) {
            this.lt.setX(point.x);
        }
        if (this.rb.x === null || point.x > this.rb.x) {
            this.rb.setX(point.x);
        }

        if (this.lt.y === null || point.y < this.lt.y) {
            this.lt.setY(point.y);
        }
        if (this.rb.y === null || point.y > this.rb.y) {
            this.rb.setY(point.y);
        }

        if (size !== null) {
            if (!(size instanceof Size)) {
                throw new Error('size must be an instance of Size');
            }
            this.addBounds(size.toBounds(point));
        }
    }

    addBounds(bounds) {
        if (!(bounds instanceof Bounds)) {
            throw new Error('bounds must be an instance of Bounds');
        }

        this.addPoint(bounds.lt);
        this.addPoint(bounds.rb);
    }

    get size() {
        return new Size(this.rb.x - this.lt.x, this.rb.y - this.lt.y);
    }

    getPoints(level) {
        let ret = [];
        for(let i = this.lt.x; i < this.rb.x; i++) {
            for(let j = this.lt.y; j < this.rb.y; j++) {
                ret.push(new Point(i, j, level));
            }
        }
        return ret;
    }

    overlaps(bounds) {
        if (!(bounds instanceof Bounds)) {
            throw new Error('bounds must be an instance of Bounds');
        }

        if (this.lt.x >= bounds.rb.x || this.rb.x <= bounds.lt.x) {
            return false;
        }
        if (this.lt.y >= bounds.rb.y || this.rb.y <= bounds.lt.y) {
            return false;
        }
        return true;
    }
}
